import React, {
  SyntheticEvent, useEffect, useRef, useState,
} from 'react';
import { createImageFromInitials } from '../../utils';
import '../../assets/style/profile-picture.scss';

type Props = {
  imageURl: string;
  name: string;
  size: number;
  className?: string;
};

const ProfilePicture = ({
  imageURl, name, size, className,
}: Props) => {
  const handleImageLoadError = (e: SyntheticEvent<HTMLImageElement, Event>) => {
    e.currentTarget.onerror = null; // prevents looping
    e.currentTarget.src = createImageFromInitials(
      size,
      name?.trim() ? name : 'Not Available',
    )!;
  };

  return (
    <img
      className={className || 'display-picture'}
      src={imageURl || createImageFromInitials(size, name || 'Not Available')}
      alt={name}
      onError={handleImageLoadError}
      width={`${size}px`}
      height={`${size}px`}
    />
  );
};

export default React.memo(ProfilePicture);
